export default "__VITE_ASSET__Xb9MPsJh__"